import React from 'react';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import Modal from '@/components/modal/Modal.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  TourConsentFormData,
  TourConsentInputData,
  tourConsentSchema,
} from '@/features/dashboard/tourConsents/schemas/tourConsentSchema.ts';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import useCreateTourConsent from '@/features/dashboard/tourConsents/hooks/useCreateTourConsent.ts';
import { tourConsentsConfigRoute } from '@/features/dashboard/tourConsents/routes/tourConsentsConfigRoute.ts';
import TourConsentForm from '@/features/dashboard/tourConsents/components/TourConsentForm.tsx';

const TourConsentAddModal = ({ onClose }: { onClose: () => void }) => {
  const { tourId } = tourConsentsConfigRoute.useParams();

  const { mutate: createConsent, isPending: isCreating } =
    useCreateTourConsent(tourId);

  const form = useForm<TourConsentInputData>({
    resolver: debugZodResolver(tourConsentSchema),
    defaultValues: {
      displayName: '',
      consentTemplateId: '',
      required: false,
      shouldSendDocumentToClient: true,
    },
  });

  const onSubmit = (data: TourConsentFormData) => {
    createConsent(
      {
        tourId,
        ...data,
      },
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Dodaj zgodę" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <TourConsentForm />

          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={isCreating}
            >
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default TourConsentAddModal;
